import { CalendarContext } from "contexts/CalendarContext";
import { useContext } from "react";

// ----------------------------------------------------------------------

const useCalendar = () => useContext(CalendarContext);

export default useCalendar;
